import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles/app.css'
import './styles/shell-studio-ai.css'
import './styles/studio-interactions.css'
import 'remixicon/fonts/remixicon.css'
createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>)
